import { useCallback } from 'react';

export const useEmitBtnClicked = () => {

  const emitBtnClicked = useCallback(() => {
    window.parent.postMessage({action: 'btnClicked'}, '*');
  }, []);

  return emitBtnClicked;
};
